export const SNOWPACK_PUBLIC_API_URL = "https://pim-dev.crystallize.digital";
export const MODE = "development";
export const NODE_ENV = "development";
export const SSR = false;